import { Box, Card, CardContent, Typography } from "@mui/material";
import React, { useState } from "react";
import { theme } from "../../Assets/Theme/theme";
import { useLocation, useNavigate } from "react-router-dom";

function Summary() {
  const navigate = useNavigate()
  const location = useLocation();
  const [isHovered, setIsHovered] = useState(false);
  const destinationName = location?.state
  const loginData = JSON.parse(localStorage.getItem("loginData"));
  const token = loginData?.token;

  return (
    <Card
      sx={{
        backgroundColor: "#fff",
        borderRadius: "8px",
        boxShadow: "0 4px 12px rgba(0, 0, 0, 0.1)",
        // padding: 2,
      }}
    >
      <CardContent
        sx={{
          minHeight: "400px",
          display: "flex",
          flexDirection: "column",
          justifyContent: "space-between",
        }}
      >
        <Box>
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              marginBottom: 3,
            }}
          >
            <Typography
              sx={{
                fontWeight: "700", fontSize: "20px",
                color: theme.colors.text,
              }}
            >
              Summary
            </Typography>
            <Typography
              component="span"
              sx={{
                color: theme.colors.orange,
                fontSize: "16px",
                cursor: "pointer",
                fontWeight: "400",
                textDecoration: isHovered ? "underline" : "none",
              }}
              onClick={() => navigate('/my-cart')}
              onMouseEnter={() => setIsHovered(true)}
              onMouseLeave={() => setIsHovered(false)}
            >
              View Cart
            </Typography>
          </Box>
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "flex-start",
              borderBottom: "1px solid #ddd",
            }}
          >
            <Box sx={{ marginBottom: 2 }}>
              <Typography
                sx={{
                  fontWeight: "400",
                  color: theme.colors.textLight,
                  fontSize: "16px",
                }}
              >
                {destinationName?.name || destinationName?.bookingData?.name}
              </Typography>
              <Typography
                sx={{
                  fontWeight: "400",
                  color: theme.colors.textLight,
                  fontSize: "16px",
                }}
              >
                {destinationName?.location || destinationName?.bookingData?.location}
              </Typography>
            </Box>
            <Box>
              <Typography
                variant="body2"
                sx={{
                  color: theme.colors.text,
                  fontWeight: "400",
                  fontSize: "16px",
                }}
              >
                {destinationName?.bookingData?.data?.currency}{destinationName?.bookingData?.data?.total}
              </Typography>
            </Box>
          </Box>
        </Box>

        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            borderTop: "1px solid #ddd",
            paddingTop: 2,
          }}
        >
          <Typography
            sx={{
              fontWeight: "400",
              fontSize: "16px",
              color: theme.colors.textLight,
            }}
          >
            Total
          </Typography>
          <Typography
            sx={{
              fontWeight: "700",
              fontSize: "16px",
              color: theme.colors.text,
            }}
          >
            {destinationName?.bookingData?.data?.currency || destinationName?.bookingData?.bookingData?.data?.currency}{destinationName?.bookingData?.data?.total || destinationName?.bookingData?.bookingData?.data?.total}
          </Typography>
        </Box>
      </CardContent>
    </Card>
  );
}

export default Summary;
